import { isObject, isString } from 'lodash';
import { curry } from 'ramda';

const customLocalStorage = {
  get: (key: string) => {
    const result = localStorage.getItem(key);
    return isString(result) ? JSON.parse(result) : result;
  },
  set: curry((key: string, value: any) => {
    if (isObject(value)) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  }),
  removeItem: (key: string) => {
    return localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  },
};
export default customLocalStorage;
